import { useCallback } from "react";
import { useEffect } from "react";
import { useMemo } from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import {
  flexBoxCenter,
  justifyContentSpaceBetween,
  justifyContentSpaceEvenly,
  layerA,
  layerA180Deg,
  layerB,
  layerBDark,
} from "shared/styles/commonStyles";
import DisplaySwitchSuggestion from "features/telemetry/components/chart/switchSytemsList/DisplaySwitchSuggestion";
import { useMediaQuery } from "react-responsive";
import {
  filteredSuggestionsHandler,
} from "shared/helpers/helpers";
import { useLocations } from "shared/hooks";

const ValveSearchBar = ({
  system,
  inputSearch,
  setInputSearch,
  setSelectSearchMethod,
}) => {

  const isMobile = useMediaQuery({ query: "(max-width:600px)" });

  const [inputSwitchName, setInputSwitchName] = useState("");

  const handleClearSearch = useCallback(() => {
    setInputSwitchName("");
    const copyInputSearch = [...inputSearch];
    copyInputSearch[0] = "";
    setInputSearch(copyInputSearch);
  }, [inputSearch, inputSwitchName]);


  const [selectedSuggestionIdx, setSelectedSuggestionIdx] = useState(0);

  const [displaySuggestions, setDisplaySuggestions] = useState(false);

  const [machineSuggestions, setMachineSuggestions] = useState(null);

  const locations = useLocations();































  const machines = useMemo(
    () =>
      Object.keys(system || {}).flatMap((location) => {
        const locationData = system?.[location];
        if (!locationData) return [];

        if (locationData.isSpecificLocation) {
          return Object.keys(locationData.subLocations || {}).flatMap(
            (subLocation) =>
              Object.keys(
                locationData.subLocations?.[subLocation]?.devices || {}
              ).map((machine) => `${subLocation} - ${machine}`)
          );
        }

        return Object.keys(locationData.devices || {}).map(
          (machine) => `${location} - ${machine}`
        );
      }),
    [system]
  );

  const filteredSuggestions = filteredSuggestionsHandler(
    machineSuggestions,
    locations,
    inputSwitchName
  );
















  useEffect(() => {
    filteredSuggestions?.length >= 1 && inputSwitchName?.length >= 2
      ? setDisplaySuggestions(true)
      : setDisplaySuggestions(false);
  }, [filteredSuggestions, inputSwitchName]);



  const handleMakeSuggestions = useCallback(() => {
    setMachineSuggestions(machines);
  }, [machines]);

  const handleSelectSuggestion = useCallback(
    (idx = 0, suggestion = "") => {
      const arr = [...inputSearch];
      arr[idx] = suggestion;
      setInputSearch(arr);
    },
    [inputSearch, setInputSearch]
  );

  const commitSuggestion = (requestedIndex = selectedSuggestionIdx) => {
    const suggestionIndex = requestedIndex >= 0 ? requestedIndex : 0;
    const suggestion = filteredSuggestions[suggestionIndex];
    if (!suggestion) return;

    handleSelectSuggestion(0, suggestion);
    setInputSwitchName("");
    setSelectedSuggestionIdx(-1);
    setDisplaySuggestions(false);
  };

  const handleKeyDown = (event) => {
    switch (event.key) {
      case "Escape": {
        setInputSearch("");
        break;
      }
      case "Enter": {
        commitSuggestion();
        break;
      }
      case "ArrowUp": {
        selectedSuggestionIdx <= -1
          ? setSelectedSuggestionIdx(-1)
          : setSelectedSuggestionIdx(selectedSuggestionIdx - 1);
        break;
      }
      case "ArrowDown": {
        selectedSuggestionIdx >= filteredSuggestions.length
          ? setSelectedSuggestionIdx(filteredSuggestions.length - 1)
          : setSelectedSuggestionIdx(selectedSuggestionIdx + 1);
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleSearchButton = () => commitSuggestion();

  const inputHandler = (e) => {
    handleSelectSuggestion(0, e.target.value);
    setInputSwitchName(e.target.value);
    setSelectedSuggestionIdx(-1);
  };

  const clearButtonHandler = () => {
    handleClearSearch();
    setSelectSearchMethod(false);
  };

  const inputClickHandler = () => {
    handleMakeSuggestions();
    setSelectSearchMethod(0);
  };

  const closeSuggestionListHandler = () => {
    setDisplaySuggestions(false);
    setInputSwitchName("");
  };

  return (
    <>
      {isMobile ? (
        <BaseLayer isMobile={true}>
          <Wrapper isMobile={true}>
            <IndentInput isMobile={true}>
              <Input
                isMobile={true}
                placeholder="search"
                type="text"
                value={inputSearch}





                onChange={inputHandler}
                onKeyDown={handleKeyDown}


                onClick={inputClickHandler}




              ></Input>
              <ClearButton
                onClick={clearButtonHandler}




                isMobile={true}
              >
                <ClearButtonHole isMobile={true}>
                  <ClearButtonTop isMobile={true}>
                    <ButtonTitle isMobile={true}>clear</ButtonTitle>
                  </ClearButtonTop>
                </ClearButtonHole>
              </ClearButton>
            </IndentInput>
            {displaySuggestions && (
              <AutoCompleteWrapper
                isMobile={true}
                isTrue={displaySuggestions}
                onMouseMove={() => setSelectedSuggestionIdx(-1)}
              >
                <AutoCompleteInnerWrapper isTrue={displaySuggestions}>
                  {filteredSuggestions.map((suggestion, index) => {
                    let isSelected =
                      filteredSuggestions.indexOf(suggestion) ===
                      selectedSuggestionIdx
                        ? true
                        : false;

                    return (
                      <DisplaySwitchSuggestion
                        key={suggestion + index}
                        column={0}
                        matchedSuggestion={suggestion}
                        isSelected={isSelected}
                        handleSelect={handleSelectSuggestion}
                        handleClose={closeSuggestionListHandler}




                      />
                    );
                  })}
                </AutoCompleteInnerWrapper>
              </AutoCompleteWrapper>
            )}
            <IndentIcon isMobile={true}>
              <SearchIcon
                isMobile={true}
                src={"/images/search-icon-white.svg"}
              />
            </IndentIcon>
            <SearchButtonBase isMobile={true}>
              <SearchButton
                isMobile={true}
                onClick={handleSearchButton}



              >
                <SearchButtonHole isMobile={true}>
                  <SearchButtonTop isMobile={true}>
                    <ButtonTitle isMobile={true}>search</ButtonTitle>
                  </SearchButtonTop>
                </SearchButtonHole>
              </SearchButton>
            </SearchButtonBase>
          </Wrapper>
        </BaseLayer>
      ) : (
        <BaseLayer>
          <Wrapper>
            <IndentInput>
              <Input
                placeholder="search"
                type="text"
                value={inputSearch}
                onChange={inputHandler}





                onKeyDown={handleKeyDown}


                onClick={inputClickHandler}




              ></Input>
              <ClearButton
                onClick={clearButtonHandler}




              >
                <ClearButtonHole>
                  <ClearButtonTop>
                    <ButtonTitle>clear</ButtonTitle>
                  </ClearButtonTop>
                </ClearButtonHole>
              </ClearButton>
            </IndentInput>
            {displaySuggestions && (
              <AutoCompleteWrapper
                isTrue={displaySuggestions}
                onMouseMove={() => setSelectedSuggestionIdx(-1)}
              >
                <AutoCompleteInnerWrapper isTrue={displaySuggestions}>
                  {filteredSuggestions.map((suggestion, index) => {
                    let isSelected =
                      filteredSuggestions.indexOf(suggestion) ===
                      selectedSuggestionIdx
                        ? true
                        : false;

                    return (
                      <DisplaySwitchSuggestion
                        key={suggestion + index}
                        column={0}
                        matchedSuggestion={suggestion}
                        isSelected={isSelected}
                        handleSelect={handleSelectSuggestion}
                        handleClose={closeSuggestionListHandler}




                      />
                    );
                  })}
                </AutoCompleteInnerWrapper>
              </AutoCompleteWrapper>
            )}
            <IndentIcon>
              <SearchIcon src={"/images/search-icon-white.svg"} />
            </IndentIcon>
            <SearchButtonBase>
              <SearchButton
                onClick={handleSearchButton}



              >
                <SearchButtonHole>
                  <SearchButtonTop>
                    <ButtonTitle>search</ButtonTitle>
                  </SearchButtonTop>
                </SearchButtonHole>
              </SearchButton>
            </SearchButtonBase>
          </Wrapper>
        </BaseLayer>
      )}
    </>
  );
};

export default ValveSearchBar;

const BaseLayer = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 271px;
          height: 34px;
        `
      : css`
          width: 385px;
          height: 32px;
        `}

  border-radius: 16px;
  ${layerA}

  ${flexBoxCenter}
`;

const Wrapper = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 269px;
          height: 32px;
        `
      : css`
          width: 383px;
          height: 30px;
        `}

  border-radius: 15px;
  ${layerA180Deg}

  ${justifyContentSpaceEvenly}
  position:relative;
`;

const IndentInput = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 170px;
          height: 26px;
          border-radius: 13px;
        `
      : css`
          width: 272px;
          height: 24px;
          border-radius: 16px;
        `}

  ${layerA}

  ${justifyContentSpaceBetween}
`;

const Input = styled.input`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 110px;
          height: 26px;
          border-radius: 13px;
        `
      : css`
          width: 190px;
          height: 24px;
          border-radius: 16px;
        `}
  background: none;

  &::placeholder {
    color: #ffff;
  }
`;

const ClearButton = styled.button`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 59px;
          height: 24px;
          border-radius: 12px;
        `
      : css`
          width: 82px;
          height: 22px;
          border-radius: 25px;
        `}

  ${layerA180Deg}

  ${flexBoxCenter}
`;

const ClearButtonHole = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 55px;
          height: 20px;
          border-radius: 13px;
        `
      : css`
          width: 76px;
          height: 16px;
          border-radius: 20px;
        `}

  ${layerB}

  ${flexBoxCenter}
`;

const ClearButtonTop = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 53px;
          height: 18px;
          border-radius: 12px;
        `
      : css`
          width: 74px;
          height: 14px;
          border-radius: 19px;
        `}

  ${layerA180Deg}


  ${flexBoxCenter}
`;

const ButtonTitle = styled.p`
  font-size: 10px;
  letter-spacing: 1px;
`;

const AutoCompleteWrapper = styled.ul`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 269px;
        `
      : css`
          width: 360px;
        `}

  padding: 2px 2px;
  text-align: left;

  position: absolute;

  top: 30px;
  left: 1px;

  z-index: 100;

  display: flex;
  flex-direction: column;

  ${layerA180Deg}

  border-radius: 12px;
  ${(p) =>
    p.isTrue ||
    css`
      display: none;
    `}
`;

const AutoCompleteInnerWrapper = styled.div`
  width: 100%;
  background: #1b2b44 0% 0%;
  box-shadow: inset 0px 0px 6px #000000;
  border-radius: 11px;
  padding: 2px 2px;

  ${(p) =>
    p.isTrue ||
    css`
      display: none;
    `}
`;

const IndentIcon = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 20px;
          height: 20px;
        `
      : css`
          width: 26px;
          height: 26px;
        `}

  border-radius: 50%;

  ${layerBDark}

  ${flexBoxCenter}
`;

const SearchIcon = styled.img`
  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 12px;
      height: 12px;
    `}
`;

const SearchButtonBase = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 69px;
          height: 26px;
          border-radius: 13px;
        `
      : css`
          width: 71px;
          height: 24px;
          border-radius: 16px;
        `}

  ${layerA}


  ${flexBoxCenter}
`;

const SearchButton = styled.button`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 67px;
          height: 24px;
          border-radius: 12px;
        `
      : css`
          width: 69px;
          height: 22px;
          border-radius: 25px;
        `}

  ${layerA180Deg}

  ${flexBoxCenter}
`;

const SearchButtonHole = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 63px;
          height: 20px;
          border-radius: 13px;
        `
      : css`
          width: 63px;
          height: 16px;
          border-radius: 20px;
        `}

  ${layerB}

  ${flexBoxCenter}
`;

const SearchButtonTop = styled.div`
  ${({ isMobile }) =>
    isMobile
      ? css`
          width: 61px;
          height: 18px;
          border-radius: 12px;
        `
      : css`
          width: 61px;
          height: 14px;
          border-radius: 25px;
        `}

  ${layerA180Deg}


  ${flexBoxCenter}
`;
